import { featureToggleMixin } from "@/mixins";
import mixins from "vue-typed-mixins";
import accountLookupResultMixin from "./accountLookupResultMixin";
const Button = () => import("@/components/Button.vue");
export default mixins(featureToggleMixin, accountLookupResultMixin).extend({
    components: { Button },
    data: () => ({
        params: {
            client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
            hosted_domain: "belajar.id",
            fetch_basic_profile: false,
            scope: "email",
        },
        // only needed if you want to render the button with the google ui
        renderParams: {
            width: 250,
            height: 50,
            longtitle: true,
        },
    }),
    methods: {
        onSuccess(googleUser) {
            this.$emit("signin:success", googleUser);
        },
        onFailure(e) {
            this.$emit("signin:failure", e);
        },
    },
});
